import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AttachmentService } from 'src/app/service/attachment.service';
import { FreeFormAgendaService } from 'src/app/service/free-form-agenda.service';
import { FreeFormMinutesService } from 'src/app/service/free-form-minutes.service';
import { AddLinkDialogComponent } from '../add-link-dialog/add-link-dialog.component';
import { MeetingService } from 'src/app/service/meeting.service';
import { AgendaTaskEditDialogComponent } from '../agenda-task-edit-dialog/agenda-task-edit-dialog.component';
import { AttachmentDialogComponent } from '../attachment-dialog/attachment-dialog.component';
import { Globals } from 'src/app/service/global';
import { BreakpointObserver, Breakpoints, BreakpointState } from '@angular/cdk/layout';
import { forkJoin, Observable, of } from 'rxjs';
import { SideNavServiceService } from 'src/app/service/side-nav-service.service';
import { PermissionService } from 'src/app/service/permission.service';
import { UtilityService } from 'src/app/service/utility.service';
declare var CKEDITOR: any;
import { environment_const, environment_msg, meetingTourValues, scheduleMeetingTourValues } from 'src/environments/environment';
import { MatMenuTrigger } from '@angular/material/menu';
import { TuleapDialogComponent } from '../tuleap-dialog/tuleap-dialog.component';
import { LoginService } from 'src/app/service/login.service';
import { NotifierService } from 'angular-notifier';
import { MinutesCollabDetails } from 'src/app/models/basicMeetingModel';
import { DatePipe } from '@angular/common';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { UtcDatePipe } from 'src/app/pipe/UtcDate.pipe';
import { HistoryComponent } from '../history/history.component';
import { HistoryDialogService } from 'src/app/service/history-dialog.service';
import { map } from 'rxjs/operators';
import { LinkNotetotaskDialogComponent } from '../link-notetotask-dialog/link-notetotask-dialog.component';
export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'MMM DD, yyyy',
    monthYearLabel: 'YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'YYYY',
  },
};
@Component({
  selector: 'app-instant-meeting-task',
  templateUrl: './instant-meeting-task.component.html',
  styleUrls: ['./instant-meeting-task.component.css'],
  providers: [{ provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },

  { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
    , DatePipe, UtcDatePipe]
})
export class InstantMeetingTaskComponent implements OnInit, AfterViewInit {
  //UI Team variable declaration

  collabVariable = 'active'
  disaleAttachmentFileIcon: any;
  @Input() hideParts: any
  showTuleapIcon = true
  disabelTuleapBtn: any;
  enableTuleapTaskAdded: any = true;
  @Input()
  deviceXs!: boolean;

  @Input()
  deviceSm!: boolean;

  @Input()
  deviceMd!: boolean;

  @Input()
  deviceLg!: boolean;

  @Input()
  deviceXl!: boolean;
  meetingTourValues = meetingTourValues
  scheduleMeetingTourValues = scheduleMeetingTourValues;
  //property for adding new class for login user is a task user.
  selectedTabName: any;
  selectedNotesList: any[] = [];

  //padlock variable
  padlock: any;
  matDialogRefs!: MatDialogRef<AttachmentDialogComponent>;
  matDialogRef!: MatDialogRef<AgendaTaskEditDialogComponent>;
  taskStatusList: any;
  taskStatusCode = new UntypedFormControl();
  isPrivate: any;
  showToolTip = false;
  taskCompleted: any;
  agendaAttachResp: any;
  attachCount: boolean = true;
  attachmentCount: any;
  attachmentTotalCnt: any = true;
  attachmentIcon = 'Y';
  @Input() pinDialogTriggered = false;

  @Input() meetingResponse: any
  editCollabData = <MinutesCollabDetails>{};
  padlockDisable: any;
  isExtraSmall: Observable<BreakpointState> = this.breakpointObserver.observe(
    Breakpoints.XSmall
  );
  isMedium: Observable<BreakpointState> = this.breakpointObserver.observe(
    Breakpoints.Medium
  )
  isSmall: Observable<BreakpointState> = this.breakpointObserver.observe(
    Breakpoints.Small
  )
  @Input() videoSectionStatusChecker: any
  disableTaskIcon: any;
  taskStatusIcon: any;
  decryptKey: string = '';
  private readonly notifier!: NotifierService;
  updatedLinkedNoteIds: any;
  updatedLinkedNotes: any;
  toLinkingNotes: any;

  constructor(private datepipe: DatePipe, private loginService: LoginService, private utility: UtilityService, private permissionService: PermissionService, public sideNavService: SideNavServiceService, private readonly breakpointObserver: BreakpointObserver, private globals: Globals, private dialog: MatDialog, public commonMinService: FreeFormMinutesService, private matDialog: MatDialog, public attachService: AttachmentService, public commonAgService: FreeFormAgendaService, private meetingService: MeetingService, public freeFormAgenda: FreeFormAgendaService, private historyDialogService: HistoryDialogService) {
    this.taskStatusList = this.globals.globaltaskStatusList;

  }
  @Input() contentEditableBoolmin: any;
  @Input() minAttrList: any;
  taskDetails: any;
  //@Output() isTaskAddedOrModified : any = new EventEmitter();

  ngOnInit(): void {
    var localDate = new Date(this.minAttrList.lastModifiedOn);
    var padLockValue = this.minAttrList.isPrivate;
    if (padLockValue == 'Y') {
      this.padlock = true;
    } else {
      this.padlock = false;
    }
    this.setCurrentStatusCodeByStatus();
  }
  ngAfterViewInit() {
    if (this.minAttrList.tuleapId == null) {
      this.disabelTuleapBtn = false;
      this.enableTuleapTaskAdded = true;
      if (localStorage.getItem("orgCode") != undefined && (localStorage.getItem("orgCode") == "CHN" || localStorage.getItem("orgCode") == "GGN" || localStorage.getItem("orgCode") == "NY")) {
        this.showTuleapIcon = true;
      } else {
        this.showTuleapIcon = false;
      }
    } else {
      this.disabelTuleapBtn = true;
      this.showTuleapIcon = false;
      this.enableTuleapTaskAdded = false;
    }
    this.commonMinService.activateAllCkeditor('agChildTask');
    var roleFlag = this.permissionService.checkRoleRightsWithNoAlert(this.utility.featureList.TASK, this.utility.permissionType.MODIFY);

    if (!roleFlag) {
      return;
    } else {
      this.getTaskUserRights();
    }


    if (this.contentEditableBoolmin == false) {
      for (var i = 0; i < document.getElementsByClassName('agChildTask').length; i++) {
        document.getElementsByClassName('agChildTask')[i].setAttribute('contenteditable', 'false')
      }
    }

    this.setCurrentStatusCodeByStatus();
    //code added to allow to make private only for created user
    if (this.minAttrList.createdBy == localStorage.getItem("userId")) {
      this.padlockDisable = false;
    } else {
      this.padlockDisable = true;
    }
    //close

  }

  handleMouseUp(noteElement: HTMLDivElement): void {
    const selection = window.getSelection();
    if (selection && selection.toString()) {
      noteElement.setAttribute('highlightIndex', '0');
    }
  }
  handleFocus(event: FocusEvent, noteElement: HTMLDivElement): void {
    this.sideNavService.closeAllAccordtion();
    this.sideNavService.smootherScroll(event.target);
    noteElement.setAttribute('highlightIndex', '0');
  }

  handleKeyDown(event: KeyboardEvent, noteElement: HTMLDivElement): void {
    this.commonAgService.trackChangesWhileEditing(
      noteElement.getAttribute('taskId')!,
      noteElement.getAttribute('agId')!,
      event,
      noteElement.getAttribute('entityType')!,
      'agMinId' + noteElement.getAttribute('taskId')
    );
    if (event.ctrlKey && event.shiftKey && event.key.toLowerCase() === 'h') {
      event.preventDefault();
      this.highlightNextText(noteElement);
    }
  }

  highlightNextText(noteElement: HTMLDivElement): void {
    const regex = environment_const.patternKey;
    const content = noteElement.textContent || '';
    const matches = Array.from(content.matchAll(regex));
    const count = matches.length;
    if (count === 0) return;

    let currentIndex = parseInt(noteElement.getAttribute('highlightIndex') || '0', 10);
    noteElement.setAttribute('highlightIndex', ((currentIndex + 1) % count).toString());

    this.applyHighlight(noteElement, matches, currentIndex);
  }

  applyHighlight(noteElement: HTMLDivElement, matches: RegExpMatchArray[], highlightIndex: number): void {
    if (!noteElement.firstChild) return;

    const selection = window.getSelection();
    const range = document.createRange();

    const match = matches[highlightIndex];
    if (!match) return;
    const start = match.index!;
    const end = start + match[0].length;


    let offset = 0;
    let found = false;
    const nodes = Array.from(noteElement.childNodes);
    for (const node of nodes) {
      const nodeLength = node.textContent?.length || 0;

      if (offset + nodeLength >= start && !found) {
        const relativeStart = start - offset;
        const relativeEnd = end - offset;

        range.setStart(node, relativeStart);
        range.setEnd(node, Math.min(relativeEnd, nodeLength));

        found = true;
        break;
      }

      offset += nodeLength;
    }

    if (found) {
      selection?.removeAllRanges();
      selection?.addRange(range);
    }
  }
  ngOnDestroy() {
    // for (var instance in CKEDITOR.instances) {
    //   CKEDITOR.instances[instance].destroy();
    // }
  }

  getMinComStatusCode() {

    if (this.meetingResponse.commonMomStatusCode == 'A') {
      this.disaleAttachmentFileIcon = false;
    }
  }

  setCurrentStatusCodeByStatus() {
    var statusCode = "";
    this.taskStatusList.forEach((data: any) => {
      if (data.codeId == this.minAttrList.status) {
        statusCode = data.code
      }
    });

    this.taskStatusCode.setValue(statusCode)
  }
  getTooltipValue(): string {
    const selectedStatus = this.taskStatusList.find((data: { code: any; }) => data.code === this.taskStatusCode.value);
    return selectedStatus ? selectedStatus.description : 'Task';
  }
  getTaskUserRights() {

    if (this.globals.roleCode == 'TU') {
      this.minAttrList.actionItemOwner.forEach((data: any) => {

        if (data.fkSecUserOwner == this.globals.userId) {

          this.selectedTabName = true;
          this.disableTaskIcon = false;
        } else {
          this.selectedTabName = false;
          this.disableTaskIcon = true;
        }
      });
    }
  }

  statusTracker(id: any, vari: any) {
    if (vari == 'active') {
      let element = (<HTMLElement>document.getElementById("agMinId" + id))
      element.contentEditable = 'false'
    }
    else if (vari == 'inActive') {
      let element = (<HTMLElement>document.getElementById("agMinId" + id))
      element.contentEditable = 'true'
    }
  }

  // used to open task edit dialog box
  taskEditDialog(curTaskUiInfo: any) {
    //
    var taskId = curTaskUiInfo.taskId;
    if (curTaskUiInfo.isFollowUpFlag == 'Y') {
      taskId = curTaskUiInfo.prevMinuteId;
    }
    this.meetingService.fetchTaskInfo(taskId).subscribe(
      (meetingRes: any) => {
        this.taskDetails = meetingRes.body
        this.matDialogRef = this.matDialog.open(AgendaTaskEditDialogComponent, {
          data: { taskData: meetingRes.body, curTaskUiInfo: curTaskUiInfo }, panelClass: ['animate__animated', 'animate__slideInLeft'],
          disableClose: true,
          position: {
            left: "0%"
          },
          maxWidth: "100%",
          maxHeight: "100vh",
          width: "50%",
          height: "100vh"
        });
        const mediumDialogSubscription = this.isMedium.subscribe(size => {
          if (size.matches) {
            this.matDialogRef.updateSize('70vw', '100vh');
          }
        })
        const smallSubscription = this.isSmall.subscribe(size => {
          if (size.matches) {
            this.matDialogRef.updateSize('100vw', '100vh');
          }
        })
        const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
          if (size.matches) {
            this.matDialogRef.updateSize('100vw', '100vh');
          }
        });
        this.matDialogRef.afterClosed().subscribe(respValue => {
          this.commonAgService.curStatus$.subscribe(resp => {
            if (this.minAttrList.taskId == resp.taskId) {
              this.minAttrList.status = resp.status;
              this.setCurrentStatusCodeByStatus();
            }
          });
          mediumDialogSubscription.unsubscribe();
          smallSubscription.unsubscribe();
          smallDialogSubscription.unsubscribe();
        });
      });

  }

  trackChanges(id: any) {
    this.showToolTip = true;
    //
    let elementCreation = document.getElementById('agMinId' + id);
    $('#agMinId' + id).css("border", "5px solid rgba(0,0,0,.12)")
  }

  removeTrackChanges(id: any) {
    $('#agMinId' + id).css("border", "0px")
    this.showToolTip = false
    //this.isTaskAddedOrModified.emit(this.minAttrList);
  }

  //used to update common task status
  overAllTaskStatusUpdate(e: any, event: any) {
    var statusCode: any
    // var taskStatusIcon = JSON.stringify(event.target.innerText)

    // this.taskStatusIcon = event.target.innerText;
    this.taskStatusList.forEach((data: any) => {
      if (data.code == this.taskStatusCode.value) {
        statusCode = data.codeId
        e.status = statusCode;
      }
    })

    this.commonMinService.updateOverAllTaskStatus(e, this.minAttrList, statusCode);



  }
  //   var taskId = e.taskId;
  //   var meetingId = e.meetingId;
  //   var taskstatus = this.taskStatusCode.value;

  //   var taskStatusUpdateJson = {

  //     "assignTo": this.minAttrList.assignedTo,
  //     "taskCommonStatus": this.taskStatusCode.value,
  //     "taskFinishDate": this.minAttrList.dueDate,
  //     "notes": this.minAttrList.noteDescription,
  //     "meetingId": this.minAttrList.meetingId,
  //     "actionItemId": this.minAttrList.taskId,
  //     "meetingTitle": this.minAttrList.meetingId,
  //     "actionItemTitle": this.minAttrList.taskTitle,
  //     "entityId": this.minAttrList.agendaId,
  //     "newactifonItemOwner": "",
  //     "createdOn": this.minAttrList.createdOn,
  //     "prevLastModifiedOn": "",
  //     "noDirtyCommit": "Y",
  //     "isPrivate": this.minAttrList.isPrivate,
  //     "movingToAgendaId": "",
  //     "fromDragAndDrop": "",
  //     "fromContextMenu": "",
  //     "noteTypeId": this.minAttrList.noteTypeId,
  //     "noteTypeCode": this.minAttrList.noteTypeCode,
  //     "taskId": this.minAttrList.taskId,
  //     "projectId": ""
  //   }
  //   //
  //   //
  //   this.meetingService.updateCommonTaskStatus(taskId, meetingId, taskstatus, taskStatusUpdateJson).subscribe(responsedata => {
  //     //
  //   });

  // }

  //padlock function

  togglePadLock(e: any) {
    // if ((e.target.textContent).trim() == "lock_open") {
    //   this.isPrivate = "Y";
    //   this.padlock = true;

    // }
    // else {
    //   this.isPrivate = "N";
    //   this.padlock = false;
    // }
    this.padlock = !this.padlock;
  this.isPrivate = this.padlock ? 'Y' : 'N';
    var data = {}
    var taskJson = {
      "meetingId": this.minAttrList.meetingId,
      //"minutesId": this.minAttrList.minutesId,
      "taskId": this.minAttrList.taskId,
      "agendaId": this.minAttrList.agendaId,
      "noteTypeId": this.minAttrList.noteTypeId,
      "isPrivate": this.isPrivate,
      "taskEditFrom": "MT",
      "noteTypeCode": this.minAttrList.noteTypeCode,
      "userId": this.globals.userId,
      "deleteFlag": 0,
      "dueDateStr": this.minAttrList.dueDateStr,
      "visitorTimeZone": this.globals.vTimeZone
    }
    var saveUrl = this.commonAgService.getSaveUrl("Y", this.minAttrList.entityType, taskJson);
    this.commonAgService.saveMinutesAttributes(data, taskJson, saveUrl, "Y").then((result: any) => {
            Object.assign(this.minAttrList, result);

      if (this.isPrivate == 'Y') {
        this.editCollabData.elementId = this.minAttrList.taskId;
        this.editCollabData.agElementId = this.minAttrList.agendaId;
        this.editCollabData.meetingId = this.minAttrList.meetingId;
        this.editCollabData.collabType = 'MINPRIVATE'
      } else {
        this.meetingResponse.agendaList.forEach((agElem: any, agIndex: any) => {

          if (agElem.agendaId == this.minAttrList.agendaId) {

            this.editCollabData.agElemPosition = agIndex;

            if (agElem.minutesList != null && agElem.minutesList != undefined) {
              agElem.minutesList.forEach((minElem: any, minIndex: any) => {

                if ((minElem.decisionId != null && minElem.decisionId == this.minAttrList.decisionId)) {

                  this.editCollabData.minElemPosition = minIndex;
                }
              });
            }
          }
        });
        this.editCollabData.elementVal = this.minAttrList;
        this.editCollabData.collabType = 'MIN';
        this.editCollabData.elementId = this.minAttrList.taskId;
        this.editCollabData.meetingId = this.minAttrList.meetingId;
      }

      this.freeFormAgenda.callPushMessageToServer(this.editCollabData, '', '');

    });
  }

  toggleResPadLock(e: any) {

    // if ((e.target.textContent).trim() == "lock_open private" || (e.target.textContent).trim() == "lock_open") {
    //   this.isPrivate = "Y";
    //   this.padlock = true;

    // }
    // else {
    //   this.isPrivate = "N";
    //   this.padlock = false;
    // }
    this.padlock = !this.padlock;
  this.isPrivate = this.padlock ? 'Y' : 'N';
    var data = {}
    var taskJson = {
      "meetingId": this.minAttrList.meetingId,
      //"minutesId": this.minAttrList.minutesId,
      "taskId": this.minAttrList.taskId,
      "agendaId": this.minAttrList.agendaId,
      "noteTypeId": this.minAttrList.noteTypeId,
      "isPrivate": this.isPrivate,
      "taskEditFrom": "MT",
      "noteTypeCode": this.minAttrList.noteTypeCode,
      "userId": this.globals.userId,
      "deleteFlag": 0,
      "dueDateStr": this.minAttrList.dueDateStr,
      "visitorTimeZone": this.globals.vTimeZone
    }
    var saveUrl = this.commonAgService.getSaveUrl("Y", this.minAttrList.entityType, taskJson);
    this.commonAgService.saveMinutesAttributes(data, taskJson, saveUrl, "Y").then((result: any) => {
      if (this.isPrivate == 'Y') {
        this.editCollabData.elementId = this.minAttrList.taskId;
        this.editCollabData.agElementId = this.minAttrList.agendaId;
        this.editCollabData.meetingId = this.minAttrList.meetingId;
        this.editCollabData.collabType = 'MINPRIVATE'
      } else {
        this.meetingResponse.agendaList.forEach((agElem: any, agIndex: any) => {

          if (agElem.agendaId == this.minAttrList.agendaId) {

            this.editCollabData.agElemPosition = agIndex;

            if (agElem.minutesList != null && agElem.minutesList != undefined) {
              agElem.minutesList.forEach((minElem: any, minIndex: any) => {

                if ((minElem.decisionId != null && minElem.decisionId == this.minAttrList.decisionId)) {

                  this.editCollabData.minElemPosition = minIndex;
                }
              });
            }
          }
        });
        this.editCollabData.elementVal = this.minAttrList;
        this.editCollabData.collabType = 'MIN';
        this.editCollabData.elementId = this.minAttrList.taskId;
        this.editCollabData.meetingId = this.minAttrList.meetingId;
      }

      this.freeFormAgenda.callPushMessageToServer(this.editCollabData, '', '');

    });
  }

  //attachment dialog

  openConfidentialDialog(e: any, m: any) {

    let attchDialog = this.dialog.open(AttachmentDialogComponent, {
      data: { e, m, "data": this.contentEditableBoolmin, "disaleAttachmentFileIcon": this.disaleAttachmentFileIcon },
      panelClass: ['animate__animated', 'animate__slideInLeft'],
      disableClose: true,
      position: {
        left: "0%"
      },
      maxWidth: "100%",
      maxHeight: "100vh",
      width: "50%",
      height: "100vh"
    })
    const mediumDialogSubscription = this.isMedium.subscribe(size => {
      if (size.matches) {
        attchDialog.updateSize('70vw', '100vh');
      }
    })
    const smallSubscription = this.isSmall.subscribe(size => {
      if (size.matches) {
        attchDialog.updateSize('100vw', '100vh');
      }
    })
    const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
      if (size.matches) {
        attchDialog.updateSize('100vw', '100vh');
      }
    });
    attchDialog.afterClosed().subscribe((response: any) => {
      mediumDialogSubscription.unsubscribe()
      smallSubscription.unsubscribe()
      smallDialogSubscription.unsubscribe()
      this.meetingService.fetchTaskInfo(e._id).subscribe((data: any) => {

        if (data != undefined) {
          var minAttrList = this.minAttrList;
          if (minAttrList != null) {
            this.minAttrList.attachmentTotalCnt = data.body.attachmentTotalCnt
            this.commonAgService.pushAttachmentCount(this.minAttrList, data.body.attachmentTotalCnt, 'AI');
          }
        }
      });
    });
    //
  }

  //agenda link dialog

  addNewLink(entityId: any, meetingId: any) {
    let linkDialog = this.dialog.open(AddLinkDialogComponent, {
      data: { entityId, meetingId, "entityType": "AI", "attachmentMode": "LI", "data": this.contentEditableBoolmin, "disaleAttachmentFileIcon": this.disaleAttachmentFileIcon },
      panelClass: ['animate__animated', 'animate__slideInLeft'],
      disableClose: true,
      position: {
        left: "0%"
      },
      maxWidth: "100%",
      maxHeight: "100vh",
      width: "50%",
      height: "100vh"
    })
    const mediumDialogSubscription = this.isMedium.subscribe(size => {
      if (size.matches) {
        linkDialog.updateSize('70vw', '100vh');
      }
    })
    const smallSubscription = this.isSmall.subscribe(size => {
      if (size.matches) {
        linkDialog.updateSize('100vw', '100vh');
      }
    })
    const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
      if (size.matches) {
        linkDialog.updateSize('100vw', '100vh');
      }
    });
    linkDialog.afterClosed().subscribe((response: any) => {
      mediumDialogSubscription.unsubscribe()
      smallSubscription.unsubscribe()
      smallDialogSubscription.unsubscribe()
      this.meetingService.fetchTaskInfo(entityId).subscribe((data: any) => {

        if (data != undefined) {
          var minAttrList = this.minAttrList;
          if (minAttrList != null) {
            this.minAttrList.attachmentTotalCnt = data.body.attachmentTotalCnt
            this.commonAgService.pushAttachmentCount(this.minAttrList, data.body.attachmentTotalCnt, 'AI');
          }
        }
      });
    });
  }
  getAttachCount(e: any) {

    this.meetingService.fetchTaskInfo(e.taskId).subscribe((data: any) => {
      this.agendaAttachResp = data.body;

      this.attachCount = false;
    });
  }

  ngOnChanges(event: any) {

    this.setCurrentStatusCodeByStatus();
  }

  // ngOnChanges(event : any){
  //   
  //   let agMinId = (<HTMLElement>document.getElementById('agMinId'+event.collbElementId.currentValue));

  //   // (<HTMLElement>document.getElementById('agMinId'+event.collbElementId.currentValue)).addEventListener('keyup', (e : any) => {
  //   
  //   
  //   // })


  //   if(this.minAttrList.rowStatus != undefined || this.minAttrList.rowStatus != null){
  //     let noteIdAccess = (<HTMLElement>document.getElementById('agMinId'+event.collbElementId.currentValue))
  //       noteIdAccess.title = this.minAttrList.rowStatus
  //   }
  //   // let noteId = document.getElementById(event)
  //   
  //   
  //   

  //   function getCaretCoordinates() {
  //     let x = 0,
  //       y = 0;
  //     const isSupported = typeof window.getSelection !== "undefined";
  //     if (isSupported) {
  //       const selection = window.getSelection();
  //       if (selection!.rangeCount !== 0) {
  //         const range = selection!.getRangeAt(0).cloneRange();
  //         range.collapse(true);
  //         const rect = range.getClientRects()[0];
  //         if (rect) {
  //           x = rect.left;
  //           y = rect.top;
  //         }
  //       }
  //     }
  //     return { x, y };
  //   }

  //   const toggleTooltip = (event: { target: any; }, contenteditable: { contains: (arg0: any) => any; }) => {

  //     const tooltip = document.getElementById("tooltip");

  //     if (contenteditable.contains(event.target)) {
  //       // window.alert("called")
  //       const { x, y } = getCaretCoordinates();

  //       tooltip!.setAttribute("aria-hidden", "false");
  //       // if(this.deviceXs == true || this.deviceSm == true || this.deviceMd == true){
  //       //   window.alert("style triggered")
  //       //   tooltip!.setAttribute(
  //       //     "style",
  //       //     `display: inline-block;
  //       //     position : absolute; 
  //       //     left: ${x - 32}px;
  //       //     top: ${y - 1100}px`
  //       //   );  
  //       // }
  //       // else{
  //         tooltip!.setAttribute(
  //           "style",
  //           `display: inline-block;
  //           position : absolute; 
  //           left: ${x - 132}px;
  //           top: ${y - 390}px`
  //         );
  //       // }
  //     } 
  //     else {
  //       tooltip!.setAttribute("aria-hidden", "true");
  //       tooltip!.setAttribute("style", "display: none;");
  //     }
  //   }

  //   window.addEventListener("click", (e) => toggleTooltip(e, agMinId));
  //   window.addEventListener("focus", (e) => toggleTooltip(e, agMinId))
  //   window.addEventListener("keyup", (e) => toggleTooltip(e, agMinId));

  // }

  createEmptyAgenda(event: any) {

    var roleFlag = this.permissionService.checkRoleRightsWithAlert(this.utility.featureList.AGENDA, this.utility.permissionType.ADD);

    if (!roleFlag) {
      return
    }
    var newAg = 'AG'
    this.commonAgService.trackAgendaEventOnClick(event, newAg);

  }

  createEmptyNote(event: any) {

    var roleFlag = this.permissionService.checkRoleRightsWithAlert(this.utility.featureList.NOTES, this.utility.permissionType.ADD);

    if (!roleFlag) {
      return
    }
    var entityType = "/nn";
    this.commonAgService.trackAgendaEventOnClick(event, entityType);

  }

  createEmptyTask(event: any) {
    var roleFlag = this.permissionService.checkRoleRightsWithAlert(this.utility.featureList.TASK, this.utility.permissionType.ADD);

    if (!roleFlag) {
      return
    }
    var entityType = "/tt";
    this.commonAgService.trackAgendaEventOnClick(event, entityType);

  }

  createEmptyDecision(event: any) {

    var roleFlag = this.permissionService.checkRoleRightsWithAlert(this.utility.featureList.NOTES, this.utility.permissionType.ADD);

    if (!roleFlag) {
      return
    }
    var entityType = "/dd";
    this.commonAgService.trackAgendaEventOnClick(event, entityType);

  }

  //add to tuleap dialog
  addToTuleapDialog(minAttrList: any, meetRes: any) {
    if ((minAttrList.assignedTo != "" && minAttrList.assignedTo != "[]" && minAttrList.dueDateStr != "" && minAttrList.dueDateStr != null) || (minAttrList.actionItemOwner.length != 0 && minAttrList.dueDateStr != "" && minAttrList.dueDateStr != null)) {
      //var formattedMeetingDate = this.datepipe.transform(this.meetingResponse.meetingDate,'YYYY-MM-dd');
      let dateParts = this.meetingResponse.meetingDate.split(' ');  // Split by space to separate date and time
      let date = dateParts[0].split('/');
      var formattedMeetingDate = `20${date[2]}-${date[1]}-${date[0]}`;
      const tuleapDialog = this.dialog.open(TuleapDialogComponent, {
        data: { taskData: minAttrList, tuleapMeetingTitle: this.meetingResponse.meetingTitle, tuleapMeetingDate: formattedMeetingDate, tuleapMeetingId: this.meetingResponse.meetingId },
        panelClass: ['animate__animated', 'animate__slideInLeft'],
        disableClose: true,
        position: {
          left: "0%"
        },
        maxWidth: "100%",
        maxHeight: "100vh",
        width: "50%",
        height: "100vh"
      })
      const mediumDialogSubscription = this.isMedium.subscribe(size => {
        if (size.matches) {
          tuleapDialog.updateSize('70vw', '100vh');
        }
      })
      const smallSubscription = this.isSmall.subscribe(size => {
        if (size.matches) {
          tuleapDialog.updateSize('100vw', '100vh');
        }
      })
      const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
        if (size.matches) {
          tuleapDialog.updateSize('100vw', '100vh');
        }
      });
      tuleapDialog.afterClosed().subscribe((response: any) => {
        if (response != null && response.body.tuleapId != null) {
          this.enableTuleapTaskAdded = false;
          this.disabelTuleapBtn = true;
          this.showTuleapIcon = false;
        } else {
          this.disabelTuleapBtn = false;
          this.enableTuleapTaskAdded = true;
        }
      });
    } else {

      this.sideNavService.alertAddToTuleapTask('show')

    }
  }



  //tuleap trackers update method to update tuleap tasks
  tuleapTrackersUpdate(taskDetails: any) {
    var trackersDetails: any;
    this.loginService.getTrackersDetails(taskDetails.tuleapId).subscribe(data => { //API call to get trackers details
      trackersDetails = data.body;
    });

    var reqJson = {

      "assignedTo": "",
      "client": trackersDetails.client,
      "plannedDuration": "",
      "plannedEndDate": "",
      "plannedStartDate": "",
      "product": trackersDetails.product,
      "projectId": trackersDetails.projectId,
      "status": "",
      "taskId": "",
      "taskTitle": "",
      "tuleapId": "", //,mandatory to send while updating tuleap task
      "userId": ""

    }
    this.loginService.saveTuleapTask(reqJson).subscribe(data => {
      if (data.body.tuleapId != null) {
        this.notifier.notify("success", "Task added to Tuleap successfully");
      }
    });

  }
  history(entityId: any, modifiedName: any) {
    var entityType = "AI";
    this.historyDialogService.openHistoryDialog(entityId, entityType, modifiedName, this.isMedium, this.isSmall, this.isExtraSmall);
  }
  blur(target: any, event: any) {
    var selectTextAsTask = (event.altKey && (event.keyCode == 78 || event.keyCode == 68 || event.keyCode == 84));//(ALT+N)
    if (selectTextAsTask) {
      this.commonMinService.triggerSaveMinutes(target, event);
    }
  }
  // openLinkToNoteDialog(meetingId?: number): void {
  //   const id = meetingId || this.meetingResponse?.meetingId;
  //   const decryptKey = this.minAttrList?.decryptKey;

  //   if (!id) {
  //     console.error('Meeting ID is not defined');
  //     return;
  //   }

  //   if (!this.minAttrList?.taskId) {
  //     console.error('Task ID is not defined');
  //     return;
  //   }

  //   const openDialogWithNormalizedData = (taskRes: any, notesDetails: any[], agendas: any[]) => {
  //     taskRes.linkedNoteIds = Array.isArray(taskRes.linkedNoteIds) ? taskRes.linkedNoteIds : [];

  //     // Combine agendas with notes
  //     const meetingDataBasedOnAgendas = agendas.map(agenda => {
  //       const relatedNotes = notesDetails.filter(note => note.agendaId === agenda.id);
  //       return {
  //         ...agenda,
  //         notes: relatedNotes
  //       };
  //     });

  //     this.dialog.open(LinkTasktonoteDialogComponent, {
  //       data: {
  //         meetingRes: meetingDataBasedOnAgendas, // pass combined agendas + notes
  //         taskRes,
  //         LinkedNoteIds: taskRes.linkedNoteIds
  //       },
  //       panelClass: ['animate__animated', 'animate__slideInLeft'],
  //       disableClose: false,
  //       position: { left: '0%' },
  //       maxWidth: '100vw',
  //       maxHeight: '100vh',
  //       width: '50%',
  //       height: '100vh',
  //       autoFocus: false
  //     });
  //   };

  //   // Step 1: fetch main task/notes for the meeting
  //   this.meetingService.fetchNotesByMeetingId(id, decryptKey).subscribe({
  //     next: (taskData: any) => {
  //       const mergedTaskRes = { ...this.minAttrList, ...taskData };

  //       // Step 2: fetch task info to get linkedNoteIds
  //       this.meetingService.fetchTaskInfo(this.minAttrList.taskId).subscribe({
  //         next: (taskRes: any) => {
  //           const linkedNoteIds: number[] = Array.isArray(taskRes.body?.linkedNoteIds)
  //             ? taskRes.body.linkedNoteIds
  //             : [];

  //           // Step 3: prepare observables for each linked note detail
  //           const noteRequests = linkedNoteIds.length > 0
  //             ? linkedNoteIds.map(noteId => this.meetingService.fetchNotesByMeetingId(noteId, decryptKey))
  //             : [];

  //           // Step 4: fetch agendas for the meeting
  //           const agendaRequest = this.meetingService.fetchAgendaListByMeeting(id);

  //           // Step 5: combine all observables
  //           forkJoin({
  //             notesDetails: noteRequests.length > 0 ? forkJoin(noteRequests) : of([]),
  //             agendas: agendaRequest
  //           }).subscribe({
  //             next: ({ notesDetails, agendas }) => {
  //               openDialogWithNormalizedData(mergedTaskRes, notesDetails.map(res => res), agendas);
  //             },
  //             error: (err) => console.error('Error fetching linked notes or agendas:', err)
  //           });
  //         },
  //         error: (err) => {
  //           console.error('Error fetching task info:', err);
  //           openDialogWithNormalizedData(mergedTaskRes, [], []);
  //         }
  //       });
  //     },
  //     error: (err: any) => {
  //       console.error('Error fetching main notes data:', err);
  //       openDialogWithNormalizedData(this.minAttrList, [], []);
  //     }
  //   });
  // }


  // Task info API call
  taskInfo: any
  agendasinfoe: any;
  openLinkToNoteDialog(meetingId?: number): void {
    const id = meetingId || this.meetingResponse?.meetingId;
    const decryptKey = this.minAttrList?.decryptKey;


    if (!id || !this.minAttrList?.taskId) {
      console.error('Meeting ID or Task ID is not defined');
      return;
    }

    // Step 1: Fetch task info first
    this.meetingService.fetchTaskInfo(this.minAttrList.taskId).subscribe({
      next: (taskRes: any) => {
        const taskInfo = taskRes.body || {};

        this.taskInfo = taskInfo;

        // Step 2: Fetch notes for the meeting
        this.meetingService.fetchNotesByMeetingId(id, decryptKey).subscribe({
          next: (notes: any[]) => {

            this.toLinkingNotes = notes || [];

            // Step 3: Fetch agendas
            this.meetingService.fetchAgendaListByMeeting(id).subscribe({
              next: (agendas: any[]) => {

                this.agendasinfoe = agendas || [];

                // Map notes to agendas
                const agendasWithNotes = this.agendasinfoe.map((agenda: { agendaId: any; }) => ({
                  ...agenda,
                  notes: this.toLinkingNotes.filter((note: { agendaId: any; }) => note.agendaId === agenda.agendaId)
                }));

                // Open dialog
                // this.dialog.open(LinkTasktonoteDialogComponent, {
                //   data: {
                //     meetingRes: this.toLinkingNotes,
                //     agendas: this.agendasinfoe,
                //     agendasWithNotes,
                //     taskRes: this.taskInfo,
                //     linkedNoteIds: Array.isArray(taskInfo.linkedNoteIds)
                //       ? taskInfo.linkedNoteIds
                //       : []
                //   },
                //   panelClass: ['animate__animated', 'animate__slideInLeft'],
                //   disableClose: false,
                //   position: { left: '0%' },
                //   maxWidth: '100vw',
                //   maxHeight: '100vh',
                //   width: '50%',
                //   height: '100vh',
                //   autoFocus: false
                // });
                this.dialog.open(LinkNotetotaskDialogComponent, {
                  data: {
                    meetingRes: this.toLinkingNotes,
                    agendas: this.agendasinfoe,
                    agendasWithNotes,
                    type: "TASK",
                    meetingTitle: this.meetingResponse.meetingTitle,
                    noteRes: this.taskInfo,
                    linkedNoteIds: Array.isArray(this.taskInfo.linkedTaskIds)
                      ? this.taskInfo.linkedTaskIds
                      : []
                  },
                  panelClass: ['animate__animated', 'animate__slideInLeft'],
                  disableClose: false,
                  position: { left: '0%' },
                  maxWidth: '100vw',
                  maxHeight: '100vh',
                  width: '50%',
                  height: '100vh',
                  autoFocus: false
                });
              },
              error: (err: any) => console.error('Error fetching agendas:', err)
            });
          },
          error: (err: any) => console.error('Error fetching task:', err)
        });
      },
      error: (err: any) => console.error('Error fetching notes:', err)
    });
  }






}


